import { createDiscreteApi } from 'naive-ui';

const { dialog } = createDiscreteApi(['message', 'dialog', 'notification', 'loadingBar']);

window.addEventListener(
  'error',
  (event) => {
    if (
      (event.target as HTMLScriptElement).localName === 'script' ||
      (event.target as HTMLScriptElement).localName === 'link'
    ) {
      // dialog.warning({
      //   type: 'warning',
      //   title: 'Tips',
      //   content: 'Detected system upgrade, click OK to automatically refresh for updates ',
      //   positiveText: 'OK',
      //   closable: false,
      //   maskClosable: false,
      //   onPositiveClick: () => {
      //     location.reload();
      //   },
      //   onNegativeClick: () => {
      //     location.reload();
      //   },
      // });
    }
  },
  true
);
